"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getByPropertyIdActionCreators = exports.getByPropertyId = void 0;
const actions_1 = require("../../actions");
exports.getByPropertyId = (actionCreators) => {
    return (propertyId) => (dispatch, getState, { api }) => __awaiter(void 0, void 0, void 0, function* () {
        dispatch(actionCreators.PRICING_DEFAULTS_GET_BY_PROPERTY_ID_REQUEST({ propertyId }));
        try {
            const pricingDefaults = yield api.pricing.getDefaultsByPropertyId(propertyId);
            dispatch(actionCreators.PRICING_DEFAULTS_GET_BY_PROPERTY_ID_RECEIVE({ propertyId, pricingDefaults }));
        }
        catch (error) {
            dispatch(actionCreators.PRICING_DEFAULTS_GET_BY_PROPERTY_ID_FAILURE({ propertyId, error }));
        }
    });
};
exports.getByPropertyIdActionCreators = () => actions_1.createActionCreators([
    'PRICING_DEFAULTS_GET_BY_PROPERTY_ID_REQUEST',
    'PRICING_DEFAULTS_GET_BY_PROPERTY_ID_RECEIVE',
    'PRICING_DEFAULTS_GET_BY_PROPERTY_ID_FAILURE'
]);
exports.default = () => exports.getByPropertyId(exports.getByPropertyIdActionCreators());
//# sourceMappingURL=actions.js.map